import { Food } from '../model/food.model';
import uuid from 'uuid4';
import {helpers} from "../helpers";

export async function storeFood(food) {
  if (!(food instanceof Food)) {
    throw new Error('Unsupported type');
  }

  const foodDto = helpers.deepClone(food);

  foodDto.externalId = uuid();

  const response = await axios.post('/foods', { foodDto });

  return {
    externalId: foodDto.externalId,
    createdOrReplacedProducts: response.data.created_or_replaced_products,
  };
}
